import { render } from "./PaymentRequestListModal.vue?vue&type=template&id=71f27973&scoped=true&ts=true"
import script from "./PaymentRequestListModal.vue?vue&type=script&lang=ts"
export * from "./PaymentRequestListModal.vue?vue&type=script&lang=ts"

import "./PaymentRequestListModal.vue?vue&type=style&index=0&id=71f27973&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f27973"]])

export default __exports__